import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, errDetail } from "@agent/lib/api";
import { useAuth } from "@agent/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/agent");
    } catch (err) {
      setError(errDetail(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm text-[#0f172a] placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-indigo-300 transition-colors";

  return (
    <div className="min-h-screen bg-[#f6f8fb] grid-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <div className="mb-10 text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-slate-200 text-xs font-medium text-slate-600 shadow-sm mb-6">
            <span className="w-2 h-2 rounded-full bg-emerald-400"></span> Your AI content agent is ready
          </span>
          <h1 className="font-display font-bold tracking-tight text-4xl sm:text-5xl text-[#0f172a]">
            Posts that <span className="grad-text">refuse to flop.</span>
          </h1>
          <p className="text-slate-500 text-sm mt-4 leading-relaxed max-w-sm mx-auto">
            TechPost Agent drafts, reviews and one-click publishes technical posts to your LinkedIn Business Page. Human-in-the-loop, always.
          </p>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl shadow-[0_4px_30px_rgba(15,23,42,0.06)] p-8">
          <p className="text-center text-[11px] tracking-[0.2em] uppercase text-slate-400 font-semibold mb-6">Authorized accounts only</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-[11px] tracking-[0.2em] uppercase text-slate-400 font-semibold block mb-1.5">Email</label>
              <input data-testid="login-email-input" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@scaturasolutions.com.au" />
            </div>
            <div>
              <label className="text-[11px] tracking-[0.2em] uppercase text-slate-400 font-semibold block mb-1.5">Password</label>
              <input data-testid="login-password-input" type="password" required minLength={6} className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p data-testid="auth-error" className="text-rose-600 text-xs font-medium">{error}</p>}
            <button data-testid="auth-submit-btn" type="submit" disabled={loading}
              className="w-full py-3 bg-[#0f172a] text-white rounded-full font-medium text-sm hover:bg-[#1e293b] transition-colors duration-150 disabled:opacity-50 flex items-center justify-center gap-2">
              {loading ? "One moment…" : "Sign in"} <ArrowRight size={15} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
